import { SVGProps } from "react";

const SvgLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 47 46"
    {...props}
  >
    <rect
      x="0.796875"
      y="0.296875"
      width="45.7161"
      height="45.4051"
      rx="22.7026"
      fill="black"
    />
    <path
      d="M12.3203 34.178H17.933L19.2591 30.2002H27.894L29.2509 34.178H34.987L26.5371 11.8223H20.7394L12.3203 34.178ZM23.6074 17.4035L26.4754 25.9141H20.7085L23.6074 17.4035Z"
      fill="white"
    />
  </svg>
);

export default SvgLogo;
